import React from 'react'
import '../css/agent.info.css'
import ReactMarkdown from 'react-markdown';
import { PUBLISHED_TXT } from '../../../utils/constants';
import { capitalize } from '../../../util';

const AgentInfo = ({ activeAgentData }) => {
  return (
    <>

      <div className="agent-info-container">
        <h3 className="agent-info-title mb-3">
          Agent Info
        </h3>
        <div className="agent-info-content">
          <div className="row agent-info-row mb-3">
            <div className="col-md-3 agent-label">Agent Name</div>
            <div className="col-md-9 agent-value">{activeAgentData?.agent_name || 'N/A'}</div>
          </div>
          <div className="row agent-info-row mb-3">
            <div className="col-md-3 agent-label">Description</div>
            <div className="col-md-9 agent-value">
              <ReactMarkdown>
                {activeAgentData?.agent_description || 'N/A'}
              </ReactMarkdown>
            </div>
          </div>
          <div className="row agent-info-row mb-3">
            <div className="col-md-3 agent-label">Status</div>
            <div className={`col-md-9 agent-value ${activeAgentData?.approval_status?.toLowerCase() === PUBLISHED_TXT?.toLowerCase()
              ? "status-published"
              : "status-default"
              }`}>
              {capitalize(activeAgentData?.approval_status) || 'N/A'}
            </div>
          </div>
          <div className="row agent-info-row mb-3">
            <div className="col-md-3 agent-label">Point of Contact</div>
            <div className="col-md-9 agent-value">{activeAgentData?.point_of_contact || 'N/A'}</div>
          </div>
        </div>
      </div>

    </>
  )
}

export default AgentInfo